import { COLOR_OPTIONS } from 'config/style';
import { css } from 'styled-components';

export const FontFamily = css`
  font-family: 'Noto Sans', sans-serif;
`;

export const Truncate = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const getBackgroundColor = (colorType: string, $bgLight?: boolean, $bgStrong?: boolean) => {
  const colorMap = {
    error: {
      light: COLOR_OPTIONS.RED_10,
      normal: COLOR_OPTIONS.RED_20,
      strong: COLOR_OPTIONS.RED_50
    },
    success: {
      light: COLOR_OPTIONS.GREEN_10,
      normal: COLOR_OPTIONS.GREEN_20,
      strong: COLOR_OPTIONS.GREEN_50
    },
    warning: {
      light: COLOR_OPTIONS.YELLOW_10,
      normal: COLOR_OPTIONS.YELLOW_20,
      strong: COLOR_OPTIONS.YELLOW_50
    },
    info: {
      light: COLOR_OPTIONS.BLUE_10,
      normal: COLOR_OPTIONS.BLUE_20,
      strong: COLOR_OPTIONS.BLUE_50
    },
    default: {
      light: COLOR_OPTIONS.NEUTRAL_10,
      normal: COLOR_OPTIONS.NEUTRAL_20,
      strong: COLOR_OPTIONS.NEUTRAL_50
    }
  };

  const colors = colorMap[colorType as keyof typeof colorMap] || colorMap.default;

  if ($bgStrong) return colors.strong;
  if ($bgLight) return colors.light;
  return colors.normal;
};

export const getTextColor = (colorType: string, $colorStrong?: boolean) => {
  const colorMap = {
    error: $colorStrong ? COLOR_OPTIONS.RED_70 : COLOR_OPTIONS.RED_60,
    success: COLOR_OPTIONS.GREEN_70,
    warning: $colorStrong ? COLOR_OPTIONS.YELLOW_70 : COLOR_OPTIONS.YELLOW_50,
    info: $colorStrong ? COLOR_OPTIONS.BLUE_70 : COLOR_OPTIONS.BLUE_60,
    default: COLOR_OPTIONS.NEUTRAL_60
  };

  return colorMap[colorType as keyof typeof colorMap] || colorMap.default;
};

export const HighlightColor = css<{ color?: string; $bgStrong?: boolean; $noBg?: boolean; $colorStrong?: boolean; $bgLight?: boolean }>`
  ${({ color = 'default', $bgStrong, $noBg, $colorStrong, $bgLight }) => {
    const backgroundColor = getBackgroundColor(color, $bgLight, $bgStrong);
    const textColor = getTextColor(color, $colorStrong);

    return css`
      ${!$noBg && `background-color: ${backgroundColor};`}
      color: ${textColor};
    `;
  }}
`;
